module.exports = __webpack_public_path__ + "static/media/119.d40f9e9b.svg";